import styled from 'styled-components'
import ButtonBase from 'components/Styled/Button'

export const Button = styled(ButtonBase)`
  width: 13em;

  ${props => props.theme.mq.small.css`
    display: block;
    width: 100%;
    margin: 0 0 2rem;
  `}
`
